<template lang="pug">
  .add-reward-to-bag-button
    button(
      :class='buttonClasses'
      :disabled='disabled'
      @click='addToBag'
      v-t='buttonText'
    )
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
  props: {
    rewardId: {
      type: String,
      required: true
    },
    isRedeemable: {
      type: Boolean,
      default: false
    },
    isRewardAddedToBag: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isAddToBagLoading: false
    }
  },

  computed: {
    buttonText () {
      if (this.isRewardAddedToBag) {
        return this.$t('buttons.added')
      } else {
        return this.isAddToBagLoading ? this.$t('buttons.adding') : this.$t('buttons.addToBag')
      }
    },

    disabled () {
      return !this.isRedeemable || this.isAddToBagLoading || this.isRewardAddedToBag
    },

    isMobile () {
      return vueSupport.isMobile
    },

    buttonClasses () {
      return ['btn', ...this.classes]
    }
  },

  methods: {
    ...mapMutations([
      'setNotification'
    ]),

    ...mapActions([
      'addRedeemableToBag'
    ]),

    async addToBag () {
      this.isAddToBagLoading = true
      const redeemableId = this.rewardId

      try {
        this.$emit('addToBag')

        await this.addRedeemableToBag({
          redeemableId
        })

        if (this.isMobile) this.notifyAddedToBag()
      } catch (error) {
        this.notifyError()
      } finally {
        this.isAddToBagLoading = false
      }
    },

    notifyAddedToBag () {
      this.setNotification({
        msg: this.$t('notifications.addedToBag'),
        link: {
          path: '/cart',
          text: this.$t('notifications.viewBagCheckout')
        }
      })
    },

    notifyError () {
      this.setNotification({
        type: 'error',
        msg: this.$t('notifications.error')
      })
    }
  }
}
</script>
